import React from 'react';

import i18n from '../../i18n';
import PropTypes from 'prop-types';
import Button from '../Button';
import styles from './MyListEntry.module.scss';

const MyListEntry = React.forwardRef(
    ({ showButton = false, handleOpenModal = () => {} }, ref) => (
        <header className={styles['MyListEntry']}>
            <div className={styles['MyListEntry__Content']}>
                <h1 className={styles['MyListEntry__Title']}>
                    {i18n.t('MyList.title')}
                </h1>

                {showButton && (
                    <Button
                        icon="share"
                        type="secondary"
                        text={i18n.t('MyList.shareList')}
                        onClick={handleOpenModal}
                        ref={ref}
                        iconColor="black800"
                        iconSize="large"
                        modifiers={[styles['MyListEntry__ShareButton']]}
                    />
                )}
            </div>
        </header>
    )
);

MyListEntry.propTypes = {
    showButton: PropTypes.bool,
    handleOpenModal: PropTypes.func,
};

export default MyListEntry;
